import { Route, Routes } from "react-router-dom";
import RegistryModule from ".";

const RegistryRoute = () => {
  return (
    <Routes>
      <Route path="/:view" element={<RegistryModule />} />
      <Route path="/*" element={<RegistryModule />} />
    </Routes>
  );
};

export default RegistryRoute;
